import React, { useState } from 'react';

const AddUserPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showAddUserPopup,setShowAddUserPopup] = useState<boolean>(false);

    const addUserToggleHandler = () => {
        setShowAddUserPopup(!showAddUserPopup);
    }
	
	return <Component showAddUserPopup={showAddUserPopup} addUserToggleHandler={addUserToggleHandler} {...props}/>;
};

export default AddUserPopupHOC;   